exports.components = {
  "component---src-templates-course-content-template-js": () => import("./../../../src/templates/CourseContentTemplate.js" /* webpackChunkName: "component---src-templates-course-content-template-js" */),
  "component---src-templates-course-part-overview-template-js": () => import("./../../../src/templates/CoursePartOverviewTemplate.js" /* webpackChunkName: "component---src-templates-course-part-overview-template-js" */),
  "component---src-templates-info-page-template-js": () => import("./../../../src/templates/InfoPageTemplate.js" /* webpackChunkName: "component---src-templates-info-page-template-js" */)
}

